import useBlockRetailUser from "../hooks/useBlockRetailUser.hook";

export default function BlockRetailUser() {
  useBlockRetailUser();

  return null;
}
